


























































































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    pageDataType,
    componentDataType
} from "../types";

import {
    HOST
} from "../global";

@Component({
    name: "BoardTeam"
})
export default class BoardTeam extends Vue {
    @Prop() public compData!: string | null;
    public HOST: string = HOST;
    isShown: boolean = false;
    isHide: boolean = true;
    // public showCard(index: any) {
    //     (this as any).isShown = true;
    //     (this as any).isHide = false;
    //   }

    public clickHandler(index: any) {
        (this as any).current_slide_number = index;
        (this as any).isShown = true;
        (this as any).isHide = false;
    }

    public hideCard() {
        (this as any).isShown = false;
        (this as any).isHide = true;
    }

    public data() {
        return {
            current_slide_number: 0,
            // cases: [{
            //         id: 1,
            //         name: "Syed Manzur Elahi",
            //         designation: "Chairman",
            //         desc: "Syed Manzur Elahi, is an Alumni of Dhaka University, having a Masters in Economics. He is the Founding Chairman of Apex Footwear Ltd., Apex Tannery Ltd., Pioneer Insurance Co. Ltd. and Mutual Trust Bank Ltd., which are all listed as “A” category on the Main Board of the Stock Exchanges. He is also the Founding Chairman of Apex Enterprises Ltd., Grey Advertising Bangladesh Ltd., Blue Ocean Footwear Ltd. and Quantum Consumer Solutions Ltd. Besides the foregoing, he also chairs ApexPharma Ltd., Apex Investments Ltd.,East West University Foundation (EWUF),ManusherJonno Foundation,and Bangladesh Freedom Foundation. He also serves on the Board of International Publications Ltd. which publishes the Financial Express, Credit Rating Agency of Bangladesh Ltd. (CRAB), Board of Trustees of Centre for Policy Dialogue (CPD) and Diabetic Association of Bangladesh.In addition to this, he is a member of Nomination and Remuneration Committee of Apex Footwear ltd. He previously served as the Chairman of the Bangladesh Association of Banks (BAB), Central Depository Bangladesh Ltd., Vice Chairman of the Bangladesh Association of Publicly Listed Companies (BAPLC) and Director of Bangladesh Bank,Sonali Bank, Bangladesh Krishi Bank, Export Promotion Bureau (EPB), Bangladesh, President of the Metropolitan Chamber of Commerce and Industry (MCCI), Member, Regulatory Reforms Commission, Member, Public Administration Reforms Commission and Trustee  of Freedom Foundation, President, Bangladesh Employers’ Association (BEA), President of the Dhaka University Alumni Association (DUAA), and Honorary Consul for Belgium in Bangladesh. He has won numerous awards for his contribution to trade and industry, which include Business Executive Award and Business Person of the Year. Besides being an eminent and well recognized industrialist and business leader, he has served twice in the Cabinet of the People’s Republic of Bangladesh, holding some of the most important portfolios, as Adviser to Caretaker Governments in the year 1996 and 2001. He has earned international recognition and respect for his leadership and professional qualities. He is also a well known philanthropist.",
            //         img: require('@/assets/images/prr.png')
            //     },
            //     {
            //         id: 2,
            //         name: "Syed Nasim Manzur",
            //         designation: "Managing Director",
            //         desc: "Syed Nasim Manzur graduated in Economics in Entrepreneurial Management from the Wharton School of the University of Pennsylvania in 1990. He is the Chairman of Landmark Footwear Ltd. and Founding Director of Apex Footwear Ltd., Quantum Consumer Solutions Ltd., Blue Ocean Footwear Ltd., Apex Investments Ltd. He is also a Director of Apex Tannery Ltd., Apex Pharma Ltd., Grey Advertising Bangladesh Ltd., Apex Enterprises Ltd., Pioneer Insurance Co. Ltd., International Publications Ltd., Sunbeams School Limited and Advisor of the Leathergoods and Footwear Manufacturers & Exporters Association of Bangladesh (LFMEAB). He is an avid art enthusiast and takes keen interest in promoting art and culture through the Society for Promotion of Bangladesh Art (SPBA). He is also a Director of an internationally acclaimed Non Government Organization called FRIENDSHIP which provides health and educational service in remote and inaccessible chars of the Northern region of the Country through self propelled floating hospitals and riverine ambulances etc. He is the past President of Metropolitan Chamber of Commerce and Industry (MCCI). He is also a regular guest speaker at the National Defence College (NDC), Mirpur, Dhaka.",
            //         img: require('@/assets/images/bt1.png')
            //     },
            //     {
            //         id: 3,
            //         name: "Kazi Sanaul Hoq",
            //         designation: "Director",
            //         desc: "Mr. Kazi Sanaul Hoq joined as Director on the Board of Apex Footwear Limited in September, 2017 as nominated by Investment Corporation of Bangladesh (ICB). He has been the Managing Director of Investment Corporation of Bangladesh since 10 August 2017, the core public sector investment bank of the country.He started his career as a Senior Officer in ICB on 25 October 1984 and served different position in the same organization. Before his joining he acted as Managing Director at Rajshahi Krishi Unnayan Bank (RAKUB). During his service life he served different Banks and Financial Institutions. He served as Managing Director (Current Charge) and Deputy Managing Director at Agrani Bank Ltd. In addition to that Kazi Sanaul Hoq served as General Manager at Bangladesh Development Bank Ltd. He also served as CEO at ICB Securities Trading Company Ltd. He has been contributing his professional expertise as the Chairman of ICB Capital Management Ltd. Apart from that he is now serving as the Director of British American Tobacco Bangladesh Co. Ltd., Linde Bangladesh Limited, GlaxoSmithKline Bangladesh Ltd., Renata Limited, Bangladesh Krishi Gobeshona Endowment Trust (BKGET), United Power Generation & Distribution Co. Ltd., Credit Rating Information and Services Ltd. (CRISL), Standard Bank Limited, National Tea Company Limited, Apex Tannery Limited, Central Depository Bangladesh Ltd. (CDBL and some other Directorship. He completed his B. Com (Hon’s) and M. Com in Accounting from the University of Dhaka.",
            //         img: require('@/assets/images/bt2.png')
            //     },
            //     {
            //         id: 4,
            //         name: "Munize Manzur",
            //         designation: "Director",
            //         desc: "Munize Manzur obtained her B.A. in English Literature from Bryn Mawr College, Pennsylvania, USA and a Masters in Broadcasting, Telecommunications and Mass Media from Temple University, Philadelphia, Pennsylvania, USA. She is the Managing Director of Sunbeams School Limited. Aside from teaching English, she performs administrational duties for effective school performance and is a member of the Governing Body for policy-making decisions. In addition to her present role, she is a member of the Board Audit Committee and Nomination and Remuneration committee of Apex Footwear Ltd. She was a founding director of Mutual Trust Bank Limited, during her time on the Board she effectively contributed as chairperson of various committees. She was also the Literary Editor of The Daily Star and author of an anthology, published in 2013.",
            //         img: require('@/assets/images/mm.png')
            //     },
            //     {
            //         id: 5,
            //         name: "Dr. Mohammed Farashuddin",
            //         designation: "Independent Director",
            //         desc: "Dr. Mohammed Farashuddin has been elected as an Independent Director on the Board of Apex Footwear Limited in May, 2017. He is the Chairperson of Board Audit Committee of Apex Footwear Limited, and Member of East West University Foundation (EWUF), Executive Council of South Asian University, Senate Member, University of Dhaka, Syndicate Member, Jagannath University, Syndicate Member, Sylhet Agricultural University and also a Member of the International Civil Service Commission (ICSC) of the United Nations for a four year term starting from January 01, 2017. Professor Mohammed Farashuddin has been appointed as the Chairperson of the Government Committee for determining the Vision, Size and Strategic Direction for Higher Education in Bangladesh 2015-2030.Previously, he has served asChairman in different Government autonomous bodies and organizations such as Planning Commission Reorganizing Committee, Pay and Service Commission-2013, Sonali Bank-1998, Palli Karma-Sahayak Foundation (PKSF), Governor of Bangladesh Bank-1998 to 2001 and others. As a Governor of Bangladesh Bank, he introduced major reforms toward health, sound and default free banking system and as the Controller of Capital Issues in the Ministry of Finance, he helped to create a new look and potentially vigorous Capital Market. He also assisted in the opening of the banking and insurance to the private sector.Dr. Mohammed Farashuddin did his BA Honors and MA in Economics from University of Dhaka. MA (Econ), MA (Political Economy) and Ph.D as an outstanding foreign student from Boston University, USA and a certificate course in Project Planning from Project Planning Centre Bradford University, UK. He has been honored with various awards home and abroad in recognition of his contribution in economics, higher education, banking and public service. Dr. Farashuddin has a good number of publications to his credit.",
            //         img: require('@/assets/images/mf.png')
            //     },
            //     {
            //         id: 6,
            //         name: "Parveen Mahmud, FCA",
            //         designation: "Independent Director",
            //         desc: "Ms. Parveen Mahmud, FCA has joined as an Independent Director on the Board of Apex Footwear Limited in November, 2018. She is the Chairperson of Nomination and Remuneration Committee (NRC) and member of Board Audit Committee of Apex Footwear Ltd. She is a fellow member of the Institute of Chartered Accountants of Bangladesh (ICAB).She was a practicing accountant and a Partner at ACNABIN, Chartered Accountants. She was the first woman President of the ICAB in 2011. She was also, the first female board member of the South Asian Federation of Accountants (SAFA), the apex accounting professional body of the SAARC. She is the Chairperson of CA Female Forum- Women in Leadership Committee (WIL), ICAB and is the Vice Chairperson of the Women Leadership Committee (WLC) of SAFA.She started her career with BRAC. In her varied professional career worked substantial time with national and international development agencies and was practicing chartered accountant. She was Deputy Managing Director in Palli Karma-Sahayak Foundation (PKSF). She was the Founding Managing Director of the Grameen Telecom Trust. She sits in numerous Boards including Transparency International Bangladesh (TIB), BRAC International, PKSF, RDRS, CAMPE, Manusher Jonno Foundation (MJF), Grameenphone Ltd., Linde Bangladesh Ltd., Berger Paints Bangladesh Ltd., etc. She is the member, of the think tank Centre for Policy Dialogue (CPD), and International Chamber of Commerce (ICC), Bangladesh. Ms. Mahmud was the Chairperson of Shasha Denims Ltd. She was the Chairperson, Acid Survivor’s Foundation and Vice Chairperson of Underprivileged Children Education Program (UCEP) - Bangladesh. She was the member of National Advisory Panel for SME Development of Bangladesh and founding board member of SME Foundation and Convenor, SME Women’s Forum. Ms. Mahmud was Working Group Member, Consultative Group on Social Indicators, UNCTAD/ISAR.She is the recipient of Joya Alokit Nari- 2018 Award from RTV, “Women at Work -2017” Award from Association of Software and Information Services (BASIS) and “Women of Inspiration Awards”-2017 from the Bangladesh Organization for Learning & Development (BOLD). Ms Mahmud received Begum Rokeya Shining Personality Award 2006 for women’s empowerment from Narikantha Foundation.",
            //         img: require('@/assets/images/aaaaasasas.png')
            //     }
            // ]
        };
    }

    public nextSlide() {
        (this as any).current_slide_number++;
    }
    public prevSlide() {
        (this as any).current_slide_number--;
    }

}
